module.exports = __webpack_public_path__ + "img/声音.cc9dede6.png";